var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoirDeliveryTruck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 34.8333C15.6391 34.8333 16.5718 34.447 17.2594 33.7594C17.947 33.0718 18.3333 32.1391 18.3333 31.1667C18.3333 30.1942 17.947 29.2616 17.2594 28.5739C16.5718 27.8863 15.6391 27.5 14.6667 27.5C13.6942 27.5 12.7616 27.8863 12.0739 28.5739C11.3863 29.2616 11 30.1942 11 31.1667C11 32.1391 11.3863 33.0718 12.0739 33.7594C12.7616 34.447 13.6942 34.8333 14.6667 34.8333ZM33 34.8333C33.9725 34.8333 34.9051 34.447 35.5927 33.7594C36.2804 33.0718 36.6667 32.1391 36.6667 31.1667C36.6667 30.1942 36.2804 29.2616 35.5927 28.5739C34.9051 27.8863 33.9725 27.5 33 27.5C32.0275 27.5 31.0949 27.8863 30.4073 28.5739C29.7196 29.2616 29.3333 30.1942 29.3333 31.1667C29.3333 32.1391 29.7196 33.0718 30.4073 33.7594C31.0949 34.447 32.0275 34.8333 33 34.8333Z",
    stroke: "#004684",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4247 31.1667H27.4997V12.1C27.4997 11.8083 27.3838 11.5285 27.1775 11.3222C26.9712 11.1159 26.6914 11 26.3997 11H1.83301M10.358 31.1667H6.59967C6.45522 31.1667 6.31218 31.1382 6.17872 31.0829C6.04526 31.0277 5.924 30.9466 5.82186 30.8445C5.71971 30.7423 5.63869 30.6211 5.58341 30.4876C5.52813 30.3542 5.49967 30.2111 5.49967 30.0667V21.0833",
    stroke: "#004684",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 16.5H10.9993",
    stroke: "#004684",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16.5H37.785C37.9976 16.5001 38.2057 16.5617 38.384 16.6776C38.5623 16.7934 38.7032 16.9584 38.7897 17.1527L42.0713 24.5373C42.1339 24.6776 42.1663 24.8293 42.1667 24.9828V30.0667C42.1667 30.2111 42.1382 30.3542 42.0829 30.4876C42.0277 30.6211 41.9466 30.7423 41.8445 30.8445C41.7423 30.9466 41.6211 31.0277 41.4876 31.0829C41.3542 31.1382 41.2111 31.1667 41.0667 31.1667H37.5833M27.5 31.1667H29.3333",
    stroke: "#004684",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirDeliveryTruck);
export default __webpack_public_path__ + "static/media/iconoir_delivery-truck.f9f1f92c02c1839e44d58983f737d255.svg";
export { ForwardRef as ReactComponent };